import { useState, useEffect } from 'react';
import Api from 'entities/helpers/api';

/**
 * Fetches org interaction types from the UGC API.
 * Returns an array of { label, value } with "Any type" as the first option.
 */
const useInteractionTypes = () => {
  const [interactionTypes, setInteractionTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fallback = [{ label: 'Any type', value: '' }];
    try {
      const request = Api.UGC.INTERACTION_TYPES.get();
      Promise.resolve(request)
        .then((resp) => {
          const types = (Array.isArray(resp) ? resp : resp?.items || [])
            .filter((t) => (typeof t === 'string' ? true : t.active !== false && !t.deleted_at))
            .map((t) =>
              typeof t === 'string'
                ? { label: t, value: t }
                : { label: t.label || t.name || t.value, value: t.value || t.name || String(t.id) }
            );
          setInteractionTypes([{ label: 'Any type', value: '' }, ...types]);
        })
        .catch(() => {
          setInteractionTypes(fallback);
        })
        .finally(() => setLoading(false));
    } catch {
      setInteractionTypes(fallback);
      setLoading(false);
    }
  }, []);

  return { interactionTypes, loading };
};

export default useInteractionTypes;
